/*
 * Visionneuse zoom (PdZoom) — photos de la fiche produit en plein écran (Babylone, 19/10/2026 : photos HD 3000 px).
 *
 *   <div class="pd-zoom" data-pd-zoom data-pd-zoom-full="/media/…/photo.jpg" data-pd-zoom-hint="…">
 *       <img src="/media-sizes/hd/…/photo.jpg" alt="…">
 *   </div>
 *
 *  • molette / double-clic / double-tap : zoom ancré sous le pointeur (×1 → ×6) ;
 *  • glisser (souris ou doigt) : déplacement ; pincement à deux doigts : zoom ;
 *  • dès qu'on zoome, la photo d'affichage (HD 1920) est remplacée par l'original (data-pd-zoom-full) ;
 *  • clavier : + / − / 0 ; Échap ferme (bouton de fermeture de la visionneuse) ;
 *  • un clic sur la photo ne ferme pas la visionneuse (le fond, oui) ; flèches : nouvelle photo = zoom remis à 1.
 * Initialisation automatique (MutationObserver) : les visionneuses Blazor apparaissent après le premier rendu.
 */
(function () {
    'use strict';
    if (window.PdZoom) return;
    var MIN = 1, MAX = 6, STEP = 1.18, DBL = 2.5;

    function init(stage) {
        if (!stage || stage.__pdZoom) return;
        var img = stage.querySelector('img');
        if (!img) return;
        stage.__pdZoom = true;
        stage.setAttribute('tabindex', '0');
        var full = stage.getAttribute('data-pd-zoom-full') || '';
        var hint = stage.getAttribute('data-pd-zoom-hint') || '';
        var scale = 1, tx = 0, ty = 0, swapped = false, moved = false, downOnImg = false, pendingSwap = '', lastPointerType = 'mouse';
        var pointers = new Map(), pinchStart = null, lastTap = 0, hintTimer = null;

        var badge = document.createElement('div');
        badge.className = 'pd-zoom__scale';
        badge.setAttribute('aria-hidden', 'true');
        stage.appendChild(badge);
        if (hint) {
            var h = document.createElement('div');
            h.className = 'pd-zoom__hint';
            h.textContent = hint;
            stage.appendChild(h);
            hintTimer = setTimeout(function () { h.classList.add('is-gone'); }, 3200);
        }

        function apply() {
            img.style.transform = 'translate(' + tx.toFixed(1) + 'px, ' + ty.toFixed(1) + 'px) scale(' + scale.toFixed(3) + ')';
            stage.classList.toggle('is-zoomed', scale > 1.001);
            badge.textContent = scale > 1.001 ? '×' + (Math.round(scale * 10) / 10).toString().replace('.', ',') : '';
            if (scale > 1.001 && full && !swapped && img.getAttribute('src') !== full) {
                swapped = true;
                var pre = new Image();
                pre.onload = function () { if (stage.__pdZoom) { pendingSwap = full; img.setAttribute('src', full); } };
                pre.src = full;
            }
        }

        function clamp() {
            scale = Math.min(MAX, Math.max(MIN, scale));
            if (scale <= 1.001) { tx = 0; ty = 0; return; }
            // La photo ne sort jamais entièrement du cadre : au plus la moitié de son débord de chaque côté.
            var r = img.getBoundingClientRect(), box = stage.getBoundingClientRect();
            var w = r.width / Math.max(scale, 0.0001) * scale, hgt = r.height;
            var maxX = Math.max(0, (w - box.width) / 2 + 24), maxY = Math.max(0, (hgt - box.height) / 2 + 24);
            tx = Math.min(maxX, Math.max(-maxX, tx));
            ty = Math.min(maxY, Math.max(-maxY, ty));
        }

        /** Zoom vers `next` en gardant le point (cx, cy) du cadre sous le pointeur. */
        function zoomAt(next, cx, cy) {
            var box = stage.getBoundingClientRect();
            var px = cx - (box.left + box.width / 2), py = cy - (box.top + box.height / 2);
            var prev = scale;
            scale = Math.min(MAX, Math.max(MIN, next));
            var k = scale / prev;
            tx = px - (px - tx) * k;
            ty = py - (py - ty) * k;
            clamp(); apply();
        }

        function reset() { scale = 1; tx = 0; ty = 0; apply(); }

        stage.addEventListener('wheel', function (e) {
            e.preventDefault();
            zoomAt(e.deltaY < 0 ? scale * STEP : scale / STEP, e.clientX, e.clientY);
        }, { passive: false });

        stage.addEventListener('dblclick', function (e) {
            e.preventDefault(); e.stopPropagation();
            // Au doigt, le double-tap est géré dans pointerup ; le dblclick natif qui le suit re-basculerait.
            if (lastPointerType === 'touch') return;
            zoomAt(scale > 1.001 ? 1 : DBL, e.clientX, e.clientY);
        });

        stage.addEventListener('pointerdown', function (e) {
            if (e.button !== undefined && e.button !== 0 && e.pointerType === 'mouse') return;
            // La capture retargette les événements suivants (dont le clic) vers le cadre : on note ici si c'est la photo.
            downOnImg = e.target === img;
            lastPointerType = e.pointerType || 'mouse';
            try { stage.setPointerCapture(e.pointerId); } catch (err) { /* pointeur synthétique ou déjà parti */ }
            pointers.set(e.pointerId, { x: e.clientX, y: e.clientY, sx: e.clientX, sy: e.clientY });
            moved = false;
            if (pointers.size === 2) {
                var p = Array.from(pointers.values());
                pinchStart = { d: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y), scale: scale };
            }
        });
        stage.addEventListener('pointermove', function (e) {
            var pt = pointers.get(e.pointerId);
            if (!pt) return;
            var dx = e.clientX - pt.x, dy = e.clientY - pt.y;
            pt.x = e.clientX; pt.y = e.clientY;
            if (Math.hypot(e.clientX - pt.sx, e.clientY - pt.sy) > 6) moved = true;
            if (pointers.size === 2 && pinchStart) {
                var p = Array.from(pointers.values());
                var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
                var cx = (p[0].x + p[1].x) / 2, cy = (p[0].y + p[1].y) / 2;
                zoomAt(pinchStart.scale * (d / Math.max(pinchStart.d, 1)), cx, cy);
                tx += dx / 2; ty += dy / 2; clamp(); apply();
                return;
            }
            if (scale > 1.001) { tx += dx; ty += dy; clamp(); apply(); e.preventDefault(); }
        });
        function up(e) {
            if (!pointers.has(e.pointerId)) return;
            pointers.delete(e.pointerId);
            if (pointers.size < 2) pinchStart = null;
            if (e.pointerType === 'touch' && !moved && pointers.size === 0) {
                var now = Date.now();
                if (now - lastTap < 320) { zoomAt(scale > 1.001 ? 1 : DBL, e.clientX, e.clientY); lastTap = 0; }
                else lastTap = now;
            }
        }
        stage.addEventListener('pointerup', up);
        stage.addEventListener('pointercancel', up);

        // Un clic sur la photo (sans glisser) n'atteint pas le fond — le fond ferme la visionneuse, pas la photo.
        stage.addEventListener('click', function (e) {
            if (downOnImg || e.target === img || scale > 1.001 || moved) { e.stopPropagation(); }
            downOnImg = false;
        });
        img.addEventListener('dragstart', function (e) { e.preventDefault(); });

        function closeViewer() {
            var overlay = stage.closest('.commerce-zoom-overlay, [role="dialog"]');
            var close = overlay && overlay.querySelector('.pd-zoom-close, button[aria-label]:last-of-type');
            if (close) { close.click(); return true; }
            return false;
        }
        // Clavier au niveau du document : après un clic sur une flèche de la visionneuse, le focus n'est plus sur le cadre.
        var onDocKey = function (e) {
            if (!document.contains(stage)) { document.removeEventListener('keydown', onDocKey, true); return; }
            if (e.defaultPrevented || e.target === stage) return;
            if (e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
            if (e.key === 'Escape') { if (closeViewer()) { e.preventDefault(); e.stopPropagation(); } }
        };
        document.addEventListener('keydown', onDocKey, true);
        stage.addEventListener('keydown', function (e) {
            var box = stage.getBoundingClientRect(), cx = box.left + box.width / 2, cy = box.top + box.height / 2;
            if (e.key === '+' || e.key === '=') { zoomAt(scale * STEP, cx, cy); e.preventDefault(); }
            else if (e.key === '-') { zoomAt(scale / STEP, cx, cy); e.preventDefault(); }
            else if (e.key === '0') { reset(); e.preventDefault(); }
            else if (e.key === 'Escape') { if (closeViewer()) e.preventDefault(); }
        });

        // Flèches de la visionneuse : Blazor change le src du même <img> → nouvelle photo, zoom remis à 1. Le seul
        // changement de src qui n'est pas une nouvelle photo est notre propre bascule vers l'original (pendingSwap).
        new MutationObserver(function () {
            var src = img.getAttribute('src') || '';
            if (pendingSwap && src === pendingSwap) { pendingSwap = ''; return; }
            full = stage.getAttribute('data-pd-zoom-full') || '';
            swapped = false; pendingSwap = '';
            reset();
        }).observe(img, { attributes: true, attributeFilter: ['src'] });
        new MutationObserver(function () { full = stage.getAttribute('data-pd-zoom-full') || ''; })
            .observe(stage, { attributes: true, attributeFilter: ['data-pd-zoom-full'] });

        apply();
        try { stage.focus({ preventScroll: true }); } catch (err) { /* ignore */ }
    }

    function scan(root) {
        if (!root || !root.querySelectorAll) return;
        if (root.matches && root.matches('[data-pd-zoom]')) init(root);
        var list = root.querySelectorAll('[data-pd-zoom]');
        for (var i = 0; i < list.length; i++) init(list[i]);
    }

    window.PdZoom = { init: init, scan: scan };
    var start = function () {
        scan(document);
        new MutationObserver(function (muts) {
            for (var i = 0; i < muts.length; i++) {
                var added = muts[i].addedNodes;
                for (var j = 0; j < added.length; j++) if (added[j].nodeType === 1) scan(added[j]);
            }
        }).observe(document.documentElement, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
